// extracted by mini-css-extract-plugin
module.exports = {"input":"Email_input_1dspc","icon":"Email_icon_3Smxu"};